export default () => {
    const $wrapper = $('.promotion-wrap');
    $wrapper.hide();

    $(window)
        .on('kr.xs', () => {
            $('#buy_block').after($wrapper);
            $wrapper.show();
        })
        .on('kr.sm', () => {

            const waitforcrossselling = setInterval(() => {
                if (document.querySelector('.similar-product-list.loaded')) {
                    $('#crossselling').append($wrapper);
                    $wrapper.show();
                    clearInterval(waitforcrossselling);
                }
            }, 150);

        })
        .on('kr.md', () => {

            const waitforcrossselling = setInterval(() => {
                if (document.querySelector('.similar-product-list.loaded')) {
                    $('#crossselling').append($wrapper);
                    $wrapper.show();
                    clearInterval(waitforcrossselling);
                }
            }, 150);

        })
        .on('kr.lg.up', () => {

            $('.promotion-wrapx').append($wrapper);
            $wrapper.show();

        });


};
